<template>
  <div v-if="block.data.items.length > 0" class="wrapper paragraph-wrapper w-mb2">
    <p v-for="(item, key) in block.data.items" v-html="item.text" :key="key"></p>
  </div>
</template>
<script>
export default {
  name: "ParagraphBlock",
  props: ["block"],
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 25px;
}
</style>
